import './App.css';
import AliatisPage from "./marketing-page/AliatisPage.tsx";

function App() {
  return (
    <AliatisPage />
  );
}

export default App;
